'use strict';

import React from 'react';
import Spinner from '../utils/spinner';
import JPEGExif from '../utils/jpeg-exif';

const THUMB_MAX_HEIGHT = 64; //px

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      error: false
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadPreview();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const divStyle = {
      width: THUMB_MAX_HEIGHT,
      height: THUMB_MAX_HEIGHT
    };

    return (
      <div
        aria-label={this.state.error ? 'error' : this.props.file.name}
        className="thumbnail_ file"
        role={this.state.error ? 'button' : 'note'}
        tabIndex="0"
        onClick={this.state.error ? () => this.props.onErrorIconClick() : null}
        onKeyPress={this.state.error ? () => this.props.onErrorIconClick() : null}
      >
        {this.state.loaded && (
          <div>
            {this.state.error
              ? <div
                className="error"
                style={divStyle}
              >
                <span className="fa-stack">
                  <i className="far fa-circle fa-stack-2x fa-inverse" />
                  <i className="fas fa-exclamation fa-stack-1x fa-inverse" />
                </span>
              </div>
              : <div><canvas height={THUMB_MAX_HEIGHT} ref="canvas" />
                <p ref="file_caption" className="file-caption file-caption-space">
                  {this.props.file.name && this.props.file.name}</p>
              </div>
            }
          </div>
        )}

        {!this.state.loaded && (
          <div style={divStyle}>
            <Spinner />
          </div>
        )}
      </div>
    );
  }


  loadPreview() {
    var component = this;
    var file = this.props.file;
    var reader = new FileReader();

    reader.onload = onReaderLoaded;
    reader.readAsDataURL(file);

    function onReaderLoaded(event) {
      if (!component._isMounted)
        return;

      var image = new Image();
      image.src = event.target.result;

      image.onload = onImageLoaded;
      image.onerror = onImageError;
    }

    function onImageError() {
      component.props.onImagePreviewError(file);
      component.setState({
        loaded: true,
        error: true
      });
    }

    function convertBase64ToArrayBuffer(string) {
      const binary = window.atob(string.split('base64,')[1]);
      const length = binary.length;
      let bytes = new Uint8Array(length);

      for (let i = 0; i < length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }

      return bytes.buffer;
    }

    function onImageLoaded(event) {
      const buffer = convertBase64ToArrayBuffer(event.target.src);
      (window.URL || window.webkitURL).revokeObjectURL(this.src);

      if (!component._isMounted)
        return;

      component.setState({
        loaded: true
      });

      const { degrees, reflectVertical, reflectHorizontal } = JPEGExif.mapping[JPEGExif.orientation(buffer)] || JPEGExif.mapping[1],
        canChangeAspectRatio = degrees == 90 || degrees == 270,
        canvas = component.refs.canvas;

      let hRatio,
        vRatio,
        ratio;

      if (!canvas) return;

      if (canChangeAspectRatio) {
        ratio = (this.width > 0) ? (THUMB_MAX_HEIGHT / this.width) : 1;
        canvas.width = this.height * ratio;
        canvas.height = this.width * ratio;
        hRatio = canvas.height / this.width;
        vRatio = canvas.width / this.height;
      } else {
        ratio = (this.height > 0) ? (THUMB_MAX_HEIGHT / this.height) : 1;
        canvas.width = this.width * ratio;
        canvas.height = this.height * ratio;
        hRatio = canvas.height / this.height;
        vRatio = canvas.width / this.width;
      }

      ratio = Math.min(hRatio, vRatio);
      const centerShift_x = (canvas.width - this.width * ratio) / 2,
        centerShift_y = (canvas.height - this.height * ratio) / 2;

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Fix issue of image caption
      const caption = component.refs.file_caption
      caption.style.width = `${canvas.width}px`
      // Rotate image according to exif orientation
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(degrees * (Math.PI / 180));
      // Reflect image according to exif mirror
      if (reflectHorizontal) {
        ctx.scale(-1, 1);
      } else if (reflectVertical) {
        ctx.scale(1, -1);
      }

      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      ctx.drawImage(
        this, 0, 0,
        this.width, this.height,
        centerShift_x, centerShift_y, this.width * ratio, this.height * ratio
      );
    }
  }
};
export default Preview;
